import { TFunction } from 'i18next';
import { EditPopupType } from '@/components/Ad/Settings/Settings.types';

export const editPopupData = (t: TFunction, dateTime?: string) => ({
  [EditPopupType.Error]: {
    title: t('common.action_not_possible'),
    description: t('pages.ad.deactivation_tip', { dateTime }),
  },
  [EditPopupType.OnReview]: {
    title: t('pages.ad.sent_on_review'),
    description: t('pages.ad.changes_will_be_applied_after_review'),
  },
});
